import importer from "common/importer";
const { deloitReq: req } = importer("APIs", null);
/**
 * @param {String} userId Takeda User ID from OKTA /authn call
 * @param {String} mfaPayload User's phone number input
 */
const main = ({ userId, mfaPayload, token }) => {
  const data = {
    userId,
    factorType: "sms",
    phoneNumber: mfaPayload,
  };

  const config = {
    headers: {
      Authorization: token,
    },
  };
  return req.post(`/auth/register-factor`, data, config);
};

export default main;
